export const storageChangeEvent = new Event("storageChange");